import { TestSuite } from '@/components/test-results/TestResults.types';
import { decorateWithIds } from '@/components/test-results/TestResults.utils';
import useMonolithApiQuery from '@/hooks/api/useMonolithApiQuery';
import { SimpleErrorResponse } from '@/models/Error';
import { buildTestResultsPath } from '@/utils/monolithApiRouteService';

export type BuildTestResults = {
  testSuites?: TestSuite[];
  testResultsError?: string;
};

type UseBuildTestResultsProps = {
  enabled: boolean;
  initialData?: BuildTestResults;
  slug: string;
};

const useBuildTestResults = ({ enabled, initialData, slug }: UseBuildTestResultsProps) =>
  useMonolithApiQuery<BuildTestResults, SimpleErrorResponse>(
    ['build', slug, 'test-results'],
    buildTestResultsPath(slug),
    {
      enabled,
      initialData: initialData ? { data: initialData } : undefined,
      select: ({ data }) => ({ ...data, testSuites: decorateWithIds(data.testSuites) }),
    },
  );

export default useBuildTestResults;
